import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import './CertListBodyLoader.css';

const MAX_COUNT = 10;
const MIN_COUNT = 1;

function CertListBodyLoader({ count }) {
  const { activeTab, tabsCount } = useSelector(
    (state) => state?.certifications?.list?.tabs
  );

  const arrCountOfItems = Array(
    Math.min(tabsCount[activeTab] || MIN_COUNT, count)
  )
    .fill()
    .map((_, index) => index + 1);

  // return <Loader kind='loop' format='main' color='brand' size='medium' />;

  return (
    <div className='CertListBodySkeleton' key={arrCountOfItems.length}>
      {arrCountOfItems.map((idx) => (
        <div
          key={idx}
          className='CertListBodySkeleton-tile CertsListSkeletonAnimation'>
          <div className='CertListBodySkeleton-icon CertsListSkeletonAnimation' />
          <div className='CertListBodySkeleton-title CertsListSkeletonAnimation' />
          <div className='CertListBodySkeleton-columns'>
            <div className='CertListBodySkeleton-columnsField CertsListSkeletonAnimation' />
            <div className='CertListBodySkeleton-columnsField CertsListSkeletonAnimation' />
          </div>
          <div className='CertListBodySkeleton-progress CertsListSkeletonAnimation' />
          <div className='CertListBodySkeleton-action CertsListSkeletonAnimation' />
        </div>
      ))}
    </div>
  );
}

CertListBodyLoader.propTypes = {
  count: PropTypes.number,
};

CertListBodyLoader.defaultProps = {
  count: MAX_COUNT,
};

export default CertListBodyLoader;
